// 引入全局样式
import './assets/css/theme.less';

import 'ant-design-vue/dist/antd.css';
// 引入自定义的 vue-awesome 样式
import './assets/css/vue-awesome-styles.css';
import Vue from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import request from '../lib/request';
import ChIcon from './components/ch-icon.vue';
// 引入 vue-awesome
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons';
// 引入路由
import router from './router';

// 引入全局工具类
import './lib/global';

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.prototype.$http = request;
Vue.component('ch-icon', ChIcon);
Vue.component('v-icon', Icon);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
